function checkBannerExpiration(expiration = "31 December") {
    let todayDate = new Date();
    let checkerDate = new Date(`${expiration}`);
    return todayDate < checkerDate
}

export const BANNER = {
    show: checkBannerExpiration("27 November 2023"),
    name: "usa-show-banner-11-28-2023",
    link: "/prices",
    clickMe: "",
    title: `BLACK FRIDAY SALE!!! GOING ON FROM NOV 23RD - NOV 26TH`,
    backgroundColor: "red",
    textColor: "white"
}

export const PROMO_SHOW_ALL = false;

export const PROMO_HEADER = {
    default: true,
    defaultTitle: "No Specials",
    defaultDescription: "There are currently no specials going on right now",
    title: "Year End Sale!",
    description: "12/30/2021 - 01/01/2022"
}

export const PROMO_PRICE_LIST = [
    {
        title: "Bulk deal 15 Lessons",
        cost: "285",
        middle: false,
        // button: {
        //     link: "https://swim-academy-scheduler-7bf36945a421.herokuapp.com",
        //     title: "Buy Lessons",
        //     color: "info"
        // },
        list: [
            {
                bold: "15",
                title: "Private 20 minute Lessons"
            },
            {
                bold: "+1",
                title: "Free Lesson"
            },
            {
                bold: "Expires",
                title: "December 31st, 2022"
            },
            {
                bold: "24",
                title: "Hours Advanced Cancellation"
            },
        ]
    },
    // {
    //     title: "Bulk deal 20 Lessons",
    //     cost: "330",
    //     middle: true,
    //     // button: {
    //     //     link: "https://swim-academy-scheduler-7bf36945a421.herokuapp.com",
    //     //     title: "Buy Lessons",
    //     //     color: "white"
    //     // },
    //     list: [
    //         {
    //             bold: "20",
    //             title: "Private 20 minute Lessons"
    //         },
    //         {
    //             bold: "+4",
    //             title: "Free Lessons"
    //         },
    //         {
    //             bold: "Expires",
    //             title: "December 30th, 2021"
    //         },
    //         {
    //             bold: "24",
    //             title: "Hours Advanced Cancellation"
    //         },
    //     ]
    // },
    {
        title: "Bulk deal 30 lessons",
        cost: "510",
        middle: false,
        // button: {
        //     link: "https://swim-academy-scheduler-7bf36945a421.herokuapp.com",
        //     title: "Buy Lessons",
        //     color: "info"
        // },
        list: [
            {
                bold: "30",
                title: "Private 20 minute Lessons"
            },
            {
                bold: "+2",
                title: "Free Lessons"
            },
            {
                bold: "Expires",
                title: "December 31st, 2022"
            },
            {
                bold: "24",
                title: "Hours Advanced Cancellation"
            },
        ]
    }
];
